import { applyMiddleware, createStore } from 'redux';
import logger from 'redux-logger';
import rootReducer from './rootReducer';

let store = null;


export default {
  configureStore(){
    store = createStore(rootReducer, applyMiddleware(logger));
    return store;
  },
  getStore(){
    return store;
  }
};
